import React from 'react';
import hello from 'hellojs';
import store from 'store';
import logo from '../images/logo.png';
import config from '../config.json';
import showContacts from '../showContacts';

const scopes = [
  'profile',
  'email'
];

hello.init({
  google: '568052108735-d9p8otk5kdlb262sbotp8g60n7c7qi9u.apps.googleusercontent.com'
}, {
  response_type: 'code',
  scope: scopes.join(', ')
});

const login = async () => {
  const googleResponse = await hello('google').login();
  const res = await fetch(`${config.api.host}${config.api.routes.token}`, {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body: JSON.stringify(googleResponse)
  });
  const credentials = await res.json();
  store.set('credentials', credentials);
  showContacts();
};

export default function Login() {
  return (
    <div style={{ maxWidth: '800px', margin: 'auto', textAlign: 'center' }}>
      <img style={{ marginTop: '25px', height: '150px' }} src={logo} alt="Logo" />
      <br />
      <button style={{ marginTop: '25px' }} className="button is-primary" onClick={login}>
        <span className="icon">
          <i className="fa fa-google" />
        </span>
        <span>Login with Google</span>
      </button>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Login.js